import { useLingui } from "@lingui/react/macro";
import { isHTTPError } from "ky";
import { useState } from "react";
import useSWRMutation from "swr/mutation";

import { isWebPath } from "~/hook/base/useIsWeb.ts";
import { validator } from "~/service/validator.ts";
import { useUser } from "~/ui/provider/Auth.tsx";
import { useNotification } from "~/ui/provider/Notification.tsx";
import { releaseToken } from "~/ui/provider/PwaProvider.tsx";

export const useQuitAccount = () => {
  const push = useNotification();
  const { t } = useLingui();
  const [password, setPassword] = useState("");
  const { client } = useUser();

  const { isMutating, trigger } = useSWRMutation(
    "user/my-info",
    (api, { arg }: { arg: { password: string } }) =>
      client.delete(api, { searchParams: arg }),
    {
      onError: (err) => {
        switch (isHTTPError(err) && err.response.status) {
          default:
            push({ content: t`다시 시도해주세요.` });
            break;
        }
      },
      onSuccess: () => {
        releaseToken();
        location.pathname = isWebPath() ? "/web" : "/";
      },
      throwOnError: false,
    },
  );

  const passwordError = validator.password(password);
  const hasError = passwordError !== null;
  const translatedPasswordError = hasError && t(passwordError);

  const handleSubmit = () => {
    void trigger({ password });
  };

  return {
    disabled: typeof passwordError === "string" || isMutating,
    handleSubmit,
    hasError,
    isMutating,
    password,
    setPassword,
    translatedPasswordError,
  };
};
